import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';

import Ottercon from 'components/ottercon';

import api from 'components/attachments/api';
import confirm from 'components/confirm';

export class AttachmentsRow extends React.Component {
  static propTypes = {
    attachment: PropTypes.shape({
      displayName: PropTypes.string,
      ottercon: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      uploadedById: PropTypes.number.isRequired,
    }),
    attachmentsPath: PropTypes.string.isRequired,
    deleteEnabled: PropTypes.bool,
    forUserId: PropTypes.number,
    onDeleteAttachment: PropTypes.func.isRequired,
  }

  handleOpen = () => {
    const { url } = this.props.attachment;
    window.open(url);
  }

  handleDelete = (event) => {
    const {
      attachment,
      onDeleteAttachment,
      attachmentsPath,
      deleteEnabled,
    } = this.props;

    event.stopPropagation();

    if (!this.canDelete()) return;

    confirm('Deleting an attachment is permanent.', {
      buttonLabel: 'Delete Attachment',
      buttonStyle: 'danger',
      title: `Delete ${attachment.displayName}?`,
    }).then(() => {
      api.deleteAttachment(attachmentsPath, attachment).then(() => {
        onDeleteAttachment(attachment);
      });
    }).catch(() => { });
  }

  canDelete() {
    const { deleteEnabled, forUserId } = this.props;
    if (!forUserId) {
      return deleteEnabled;
    }
    return deleteEnabled || (forUserId === this.props.attachment.uploadedById);
  }

  render() {

    const { displayName, ottercon } = this.props.attachment;

    return (
      <tr className="clickable" onClick={this.handleOpen}>
        <td className="fixed-width">
          <Ottercon ottercon={ottercon} size="xs" />
        </td>
        <td className="name" name="display-name">
          {displayName}
        </td>
        {this.renderControls()}
      </tr>
    );
  }

  renderControls() {
    const canDeleteRow = this.canDelete();

    const icon = (
      <FontAwesomeIcon
        aria-label="delete attachment"
        className={classNames('clickable', { 'text-muted': !canDeleteRow })}
        icon={faTrashAlt}
        name="delete"
        onClick={this.handleDelete}
      />
    );

    const overlay = (
      <Tooltip id="delete-disabled">
        Only the attachment uploader and Back Office administrators can delete attachments.
      </Tooltip>
    );

    return (
      <td className="actions fixed-width">
        {canDeleteRow ? icon :
          <OverlayTrigger overlay={overlay} placement="left">
            {icon}
          </OverlayTrigger>
        }
      </td>
    );
  }
}

export default AttachmentsRow;
